import React from 'react';
import classes from "./BigMeshA.module.css";


type BigMeshAProps = {
    img : string
}

const BigMeshA:React.FC<BigMeshAProps> = ({img}) => {
  return (
      <div className={classes["big-mesh-a-root"]}>
        <img src={img} alt="Mesh Preview" />
    </div>
  )
}

export default BigMeshA